<template>
  <div v-if="!hideTabbar"
       class="tabbar fixed bottom-0 left-0 right-0 grid grid-cols-5 gap-2 bg-white min-h-[60px] w-full shadow z-1 border-t">
    <nuxt-link :class="iconActiveClass('index')" :to="$routerUrl('/')"
               class="flex flex-col items-center justify-center">
      <van-icon :alt="$t('menu.home')"
                :name="tabIcons.index"
                size="24"/>
      <span :class="iconTextActiveClass('index')"
            class="text-[10px] mt-1">{{ $t('menu.home') }}</span>
    </nuxt-link>
    <nuxt-link :class="iconActiveClass('categories')" :to="$routerUrl('/categories')"
               class="flex flex-col items-center justify-center">
      <van-icon
          :alt="$t('menu.categories')"
          :name="tabIcons.categories"
          size="24"/>
      <span :class="iconTextActiveClass('categories')"
            class="text-[10px] mt-1">{{ $t('menu.categories') }}</span>
    </nuxt-link>
    <!--    <experiment-wrapper :flag="EXPERIMENT_KEYS.VIDEO_OR_BRANDS" #default="{isNew}" @loaded="onLoaded">-->
    <!--      <template v-if="isNew">-->
    <!--        <nuxt-link :to="$routerUrl('/videos')" class="flex flex-col items-center justify-center">-->
    <!--          <van-icon :alt="$t('menu.videos')"-->
    <!--                    :name="$publicPath(`/images/tabbar/${activeTab === 'videos' ? 'video-active' : 'video'}.svg`)"-->
    <!--                    size="24"/>-->
    <!--          <span :class="activeTab === 'brands' ? 'text-color-[#000]' : 'text-color-[#0000008a]'"-->
    <!--                class="text-[10px] mt-1">{{ $t('menu.videos') }}</span>-->
    <!--        </nuxt-link>-->
    <!--      </template>-->
    <!--      <template v-else>-->
    <!--        <nuxt-link :to="$routerUrl('/brands')" class="flex flex-col items-center justify-center">-->
    <!--          <van-icon :alt="$t('menu.brands')"-->
    <!--                    :name="$publicPath(`/images/tabbar/${activeTab === 'brands' ? 'brands-active' : 'brands'}.svg`)"-->
    <!--                    size="24"/>-->
    <!--          <span :class="activeTab === 'brands' ? 'text-color-[#000]' : 'text-color-[#0000008a]'"-->
    <!--                class="text-[10px] mt-1">{{ $t('menu.brands') }}</span>-->
    <!--        </nuxt-link>-->
    <!--      </template>-->
    <!--    </experiment-wrapper>-->
    <nuxt-link :class="iconActiveClass('brands')" :to="$routerUrl('/brands')"
               class="flex flex-col items-center justify-center">
      <van-icon :alt="$t('menu.brands')"
                :name="tabIcons.brands"
                size="24"/>
      <span :class="iconTextActiveClass('brands')"
            class="text-[10px] mt-1">{{ $t('menu.brands') }}</span>
    </nuxt-link>
    <nuxt-link :class="iconActiveClass('cart')" :to="$routerUrl('/cart')"
               class="cart relative flex flex-col items-center justify-center">
      <van-badge :content="count" :max="99" :position="$i18n.locale === 'en' ? 'top-right' : 'top-left'"
                 :show-zero="false" color="#EE2D64">
        <van-icon :alt="$t('menu.cart')"
                  :name="tabIcons.cart"
                  size="24"/>
      </van-badge>
      <span :class="iconTextActiveClass('cart')"
            class="text-[10px] mt-1">{{ $t('menu.bag') }}</span>
    </nuxt-link>
    <nuxt-link :class="iconActiveClass('account')" :to="$routerUrl('/account')"
               class="flex flex-col items-center justify-center">
      <van-icon :alt="$t('menu.account')"
                :name="tabIcons.account"
                size="24"/>
      <span :class="iconTextActiveClass('account')"
            class="text-[10px] mt-1">{{ $t('menu.account') }}</span>
    </nuxt-link>
  </div>
</template>

<script setup>
import {isAppView} from "@/utilities";
import {useCartStore} from '@/store/cart'
import {useContentStore} from "@/store/content";
import {useRouteMatcher} from "@/composables/useRouteMatcher";
import {PAGES_NAMES, TABBAR_NOT_ALLOWED_ROUTES} from "@/constants/pages";

const route = useRoute()
const activeTab = computed(() => route?.name?.split('_')?.[0] || PAGES_NAMES.HOME)

const iconActiveClass = (tab) => activeTab.value === tab ? 'active-tab text-[#8360D9]' : 'text-primary';
const iconTextActiveClass = (tab) => activeTab.value === tab ? 'text-secondary font-medium' : 'text-[#7D7E82]'

const tabIcons = computed(() => ({
  index: useNuxtApp().$publicPath(`/images/tabbar/${activeTab.value === 'index' ? 'home-active' : 'home'}.svg`),
  categories: useNuxtApp().$publicPath(`/images/tabbar/${activeTab.value === 'categories' ? 'category-active' : 'category'}.svg`),
  brands: useNuxtApp().$publicPath(`/images/tabbar/${activeTab.value === 'brands' ? 'brands-active' : 'brands'}.svg`),
  cart: useNuxtApp().$publicPath(`/images/tabbar/${activeTab.value === 'cart' ? 'cart-active' : 'cart'}.svg`),
  account: useNuxtApp().$publicPath(`/images/tabbar/${activeTab.value === 'account' ? 'account-active' : 'account'}.svg`),
}));

const {isRouteMatched} = useRouteMatcher();

const hideTabbar = computed(() => useNuxtApp().$device.isDesktop || isAppView.value || isRouteMatched(TABBAR_NOT_ALLOWED_ROUTES))

const cartStore = useCartStore()
const {count} = storeToRefs(cartStore)

const contentStore = useContentStore()
const onLoaded = (value) => contentStore.enableVideoTab = value
</script>

<style>
.cart .van-badge__wrapper .van-icon {
  display: initial !important;
}

.active-tab {
  position: relative;
}

.active-tab::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  width: 28px;
  height: 2px;
  background-color: currentColor;
  transform: translateX(-50%);
  border-radius: 12px;
}
</style>